import React, { useState } from "react";
import { Doughnut, Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import Share from "SanityComponents/ShareCredits/Share";
import { COUNTRY_CONFIG } from "../../../../../Config/country";
import { selectors as MensualSelectors } from "../../../../../redux/slices/v2/CaclulezMensualite";
import style from "./style.module.css";

function PrixDeBien({ t, lang }: { t: any; lang: any }) {
  const [checked, setChecked] = useState<boolean>(false);
  const [showShare, setShowShare] = useState<boolean>(false);

  const PrixDeBien = useSelector(MensualSelectors.mensualPrixDeBien);
  const Acompte = useSelector(MensualSelectors.mensualAcompte);
  const Programe = useSelector(MensualSelectors.mensualProgramme);
  const Taux = useSelector(MensualSelectors.mensualTaux);

  const Mensualite = useSelector(MensualSelectors.MensualiteSelector);
  const Taxes = useSelector(MensualSelectors.TaxesSelector);
  const PANDI = useSelector(MensualSelectors.PANDISelector);
  const Assurances = useSelector(MensualSelectors.AssurancesSelector);
  const Capital_restant = useSelector(MensualSelectors.Capital_restantSelector);
  const interets_cumules = useSelector(
    MensualSelectors.interets_cumulesSelector
  );
  const principal_rembourse = useSelector(
    MensualSelectors.principal_rembourseSelector
  );

  const data = {
    name: "doughnut",
    datasets: [
      {
        data: [Taxes, Assurances, PANDI],
        backgroundColor: ["#8ae1ff", "#00B4FF", "#460AF0"],
      },
    ],
    labels: [t("Taxes"), t("Assurances"), t("P&I")],
  };

  const LineData: any = {
    name: "line",
    datasets: [
      {
        label: t("Capital restant"),
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgba(75,192,192,0.4)",
        borderColor: "#32E696",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "#32E696",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#32E696",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: Capital_restant,
      },
      {
        label: t("Intérêts cumulés"),
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgba(75,192,192,0.4)",
        borderColor: "#00B4FF",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "#00B4FF",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#00B4FF",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: interets_cumules,
      },
      {
        label: t("Principal remboursé"),
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgba(75,192,192,0.4)",
        borderColor: "#460AF0",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "#460AF0",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#460AF0",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: principal_rembourse,
      },
    ],
    labels: [
      ...Array(Capital_restant.length ? Capital_restant.length - 1 : 1).keys(),
    ].map((item) => {
      return t(`Mois ${item + 1}`);
    }),
  };

  const options: any = {
    cutout: 100,
    center: {
      text: "Red is 2/3 the total numbers",
      color: "#FF6384",
      fontStyle: "Arial",
      sidePadding: 20,
      minFontSize: 20,
      lineHeight: 25,
    },

    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          return data["labels"][tooltipItem[0]["index"]];
        },
        label: function (tooltipItem, data) {
          return `${parseInt(
            data["datasets"][0]["data"][tooltipItem["index"]]
          )} MAD`;
        },
        afterLabel: function (tooltipItem, data) {
          var dataset = data["datasets"][0];
          return "";
        },
      },
      backgroundColor: "#FFF",
      titleFontSize: 16,
      titleFontColor: "#00B4FF",
      bodyFontColor: "#000",
      bodyFontSize: 14,
      displayColors: true,
    },
    responsive: true,
    cutoutPercentage: 85,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        usePointStyle: "true",
        onClick: function (event, legendItem) {},
        labels: {
          onClick: function (event, legendItem) {},
          fontSize: 12,
          padding: 10,
          fontColor: "#6D7278",
          fontFamily: "kanit light",
        },
      },
    },
  };

  const lineOptions: any = {
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 0,
        ticks: {
          beginAtZero: true,
          min: 100,
          callback: function (value, index, ticks) {
            return (
              value +
              " " +
              COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY].CURRENCY
            );
          },
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        usePointStyle: "true",
        align: "start",
        onClick: function (event, legendItem) {},
        labels: {
          onClick: function (event, legendItem) {},
          padding: 20,
        },
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItem, data) {
            if (
              tooltipItem[0].dataIndex >=
              tooltipItem[0].dataset.data.length - 2
            ) {
              return `Dernier mois`;
            } else {
              if (tooltipItem[0].dataIndex) {
                return `Mois ${tooltipItem[0].dataIndex}`;
              } else {
                return "Premier mois";
              }
            }
          },
          label: function (tooltipItem, data) {
            return `${parseInt(tooltipItem.raw)} ${
              COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY].CURRENCY
            }`;
          },
          afterLabel: function (tooltipItem, data) {
            return "";
          },
        },
      },
      backgroundColor: "#FFF",
      titleFontSize: 16,
      titleFontColor: "#00B4FF",
      bodyFontColor: "#000",
      bodyFontSize: 14,
      displayColors: true,
    },
  };

  // const linkToShare = `http://www.agenz.ma/credit-immobilier/simulateur-de-mensualite-credit/rapport-detaille?prixDeBien=${PrixDeBien}&acomptePrix=${Acompte.prix}&acomptePercent=${Acompte.percent}&programme=${Programe}&taux=${Taux}`
  const linkToShare = `http://www.agenz.ma/credit-immobilier/simulateur-de-mensualite-credit`;
  return (
    <div className={style.ChartsContainer}>
      {showShare ? (
        <Share
          setShowShare={setShowShare}
          linkToShare={linkToShare}
          t={t}
          lang={lang}
          message={"Calculez votre mensualite sur agenz"}
        />
      ) : null}
      <div className={style.buttonsContainer}>
        <p
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.location.href = `/${lang}/credit-immobilier/simulateur-de-mensualite-credit/rapport-detaille?prixDeBien=${PrixDeBien}&acomptePrix=${Acompte.prix}&acomptePercent=${Acompte.percent}&programme=${Programe}&taux=${Taux}`;
          }}
        >
          {t("Rapport détaillé")}
        </p>
        <button onClick={() => setShowShare(true)}>
          <span>
            <svg
              width="24"
              height="18"
              viewBox="0 0 24 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.2088 3.95909C15.2081 3.95909 15.2076 3.95966 15.2076 3.96036C15.2069 4.34633 14.8967 4.67062 14.5009 4.68537C10.1931 4.8651 6.65237 6.34967 4.11861 8.83382C2.14577 10.7677 0.773028 13.3217 0.119291 16.3575C0.0785149 16.5468 0.307342 16.6724 0.452162 16.5438C2.0665 15.11 3.81457 14.1375 5.70599 13.5682C8.38612 12.7607 11.3237 12.7705 14.5514 13.4033C14.9224 13.4426 15.2101 13.7553 15.2101 14.1295V17.0284C15.2101 17.205 15.4222 17.2949 15.5491 17.1722L23.8513 9.14499C23.9326 9.06639 23.9326 8.93606 23.8513 8.85745L15.5491 0.827906C15.4222 0.705149 15.2101 0.795093 15.2101 0.971669V3.95782C15.2101 3.95852 15.2095 3.95909 15.2088 3.95909Z"
                fill="white"
              />
            </svg>
          </span>
          {t("Partager")}
        </button>
      </div>
      <div className={style.ResultContainer}>
        <div className={style.graphes}>
          <p
            className={`${!checked ? style.checked : ""}`}
            onClick={() => {
              setChecked(!checked);
            }}
          >
            {t("Décomposition")}
          </p>
          <p
            className={`${checked ? style.checked : ""}`}
            onClick={() => {
              setChecked(!checked);
            }}
          >
            {t("Echéance")}
          </p>
        </div>
        <div className={style.subBarContainer}>
          {!checked ? (
            <div className={style.doughnut} style={{ position: "relative" }}>
              <Doughnut
                data={data}
                options={options}
                width={400}
                height={350}
              />
              <div className={style.graphetext}>
                <p className={style.paiment}>{t("Paiement")}</p>
                <p className={style.graphePrice}>
                  {" "}
                  {Mensualite | 0} {t("MAD")}
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className={style.grapheLine}>
            {checked ? <Line data={LineData} options={lineOptions} /> : ""}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrixDeBien;
